module.exports = __webpack_public_path__ + "static/21-04-22_13-35-31_5404-1500x1125-d96d97588fddb9aeac9b565957dbb3fa.jpg";